import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ExternalOrderResponse,
  CompleteOrderResponse
} from 'src/app/share/types';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalOrderService {
  private readonly EXTERNAL_ORDER_PATH = '/api/v1/order/legacy';
  private readonly COMPLETE_ORDER_PATH = '/api/v1/order/legacy/complete';

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  // Get external order information from external system
  getExternalOrderInfo(externalId: string): Observable<ExternalOrderResponse> {
    const baseUrl = this.configService.getExternalOrderApiBaseUrl();
    return this.http.get<ExternalOrderResponse>(
      `${baseUrl}${this.EXTERNAL_ORDER_PATH}?id=${externalId}`,
      {
        headers: {
          'ngrok-skip-browser-warning': 'true'
        }
      }
    );
  }

  // Complete an external order by marking it as complete
  completeOrder(externalId: string, orderId: string): Observable<CompleteOrderResponse> {
    const baseUrl = this.configService.getExternalOrderApiBaseUrl();
    return this.http.put<CompleteOrderResponse>(
      `${baseUrl}${this.COMPLETE_ORDER_PATH}`,
      { id: externalId, orderNo: orderId.toString() },
      {
        headers: {
          'ngrok-skip-browser-warning': 'true'
        }
      }
    );
  }
}
